import { PERIOD_FILTERS } from '../constants/financial';

const MONTHS = [
  'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
];

export const MONTHS_SHORT = MONTHS.map((m) => m.slice(0, 3));

export const getMonthName = (index) => MONTHS[index];

export const getCurrentPeriod = () => {
  const now = new Date();
  return `${MONTHS[now.getMonth()]} ${now.getFullYear()}`;
};

// Formata Date como ISO YYYY-MM-DD usando timezone local (evita o bug
// noturno em UTC-3 onde toISOString().split('T')[0] retorna o dia seguinte).
export const formatLocalISO = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

const toISODate = (date) => formatLocalISO(date);

const monthRange = (year, month) => ({
  from: toISODate(new Date(year, month, 1)),
  to: toISODate(new Date(year, month + 1, 0)),
});

const quarterRange = (year, month) => {
  const startMonth = Math.floor(month / 3) * 3;
  return {
    from: toISODate(new Date(year, startMonth, 1)),
    to: toISODate(new Date(year, startMonth + 3, 0)),
  };
};

const yearRange = (year) => ({
  from: toISODate(new Date(year, 0, 1)),
  to: toISODate(new Date(year, 11, 31)),
});

export const getMonthPeriod = (year, month) => ({
  label: `${MONTHS[month]} ${year}`,
  range: monthRange(year, month),
});

export const getYearPeriod = (year) => ({
  label: `Ano ${year}`,
  range: yearRange(year),
});

export const getCurrentQuarterPeriod = () => {
  const now = new Date();
  return { label: 'Trimestre', range: quarterRange(now.getFullYear(), now.getMonth()) };
};

export const getPeriodOptions = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  const prevMonth = (month + 11) % 12;
  const prevYear = month === 0 ? year - 1 : year;

  return [
    getMonthPeriod(year, month),
    getMonthPeriod(prevYear, prevMonth),
    getCurrentQuarterPeriod(),
    getYearPeriod(year),
  ];
};

export const getCurrentPeriodRange = () => {
  const now = new Date();
  return monthRange(now.getFullYear(), now.getMonth());
};

export const todayISO = () => formatLocalISO(new Date());

export const startOfWeekISO = () => {
  const d = new Date();
  const day = d.getDay();
  const diff = d.getDate() - day;
  d.setDate(diff);
  return formatLocalISO(d);
};

export const endOfWeekISO = () => {
  const d = new Date();
  const day = d.getDay();
  const diff = d.getDate() - day + 6;
  d.setDate(diff);
  return formatLocalISO(d);
};

export const startOfMonthISO = () => {
  const d = new Date();
  return formatLocalISO(new Date(d.getFullYear(), d.getMonth(), 1));
};

export const endOfMonthISO = () => {
  const d = new Date();
  return formatLocalISO(new Date(d.getFullYear(), d.getMonth() + 1, 0));
};

export const nextNMonthsRange = (months) => {
  const today = new Date();
  const end = new Date(today.getFullYear(), today.getMonth() + months, today.getDate());
  return { from: formatLocalISO(today), to: formatLocalISO(end) };
};

// Rótulo legível do período selecionado, p/ cabeçalho de relatórios (RN05/CA07).
// Reaproveita os labels de PERIOD_FILTERS; no modo 'periodo' formata o range custom.
export const getPeriodLabel = (filter, custom = {}) => {
  if (filter === 'todos') return 'Todos os períodos';
  if (filter === 'periodo') {
    const fmt = (iso) => (iso ? new Date(iso + 'T00:00:00').toLocaleDateString('pt-BR') : '—');
    return `${fmt(custom.from)} até ${fmt(custom.to)}`;
  }
  const option = PERIOD_FILTERS.find((p) => p.key === filter);
  return option ? option.label : '—';
};

export const getRangeFromFilter = (filter, custom) => {
  switch (filter) {
    case 'todos':
      return { from: null, to: null };
    case 'hoje':
      return { from: todayISO(), to: todayISO() };
    case 'semana':
      return { from: startOfWeekISO(), to: endOfWeekISO() };
    case 'mes':
      return { from: startOfMonthISO(), to: endOfMonthISO() };
    case 'proximos2meses':
      return nextNMonthsRange(2);
    case 'periodo':
      return { from: custom.from, to: custom.to };
    default:
      return { from: todayISO(), to: todayISO() };
  }
};
